module.exports = __webpack_public_path__ + "img/223.b43d0a6f.jpg";